const GATEWAY_CONFIG = {
  cod: {
    label: "Cash on Delivery",
    image: `${process.env.PUBLIC_URL}/img/logo.png`,
    description:
      "Pay with cash upon delivery of your order. Ideal for hassle-free offline payments.",
    fields: [
      {
        name: "maxOrderValue",
        label: "Maximum Order Amount",
        type: "text",
        placeholder: "e.g. 10000",
        helperText:
          "Maximum order value allowed for COD to reduce high-value order risks.",
      },
    ],
  },
  partial: {
    label: "Partial Advance Payment",
    image: `${process.env.PUBLIC_URL}/img/logo.png`,
    description: "Collect a small advance online and remaining amount as COD.",
    fields: [
      {
        name: "advanceGateway",
        label: "Advance Gateway",
        type: "select",
        options: [
          { label: "Select Gateway", value: "" },
          { label: "Razorpay", value: "razorpay" },
          { label: "PayU", value: "payu" },
        ],
        helperText: "Online gateway to collect advance amount.",
      },
      {
        name: "advanceType",
        label: "Advance Calculation Type",
        type: "select",
        options: [
          { label: "Flat Amount (₹)", value: "flat" },
          { label: "Percentage (%)", value: "percent" },
        ],
        helperText: "Calculate advance as fixed amount or percentage of total.",
      },
      {
        name: "advanceValue",
        label: "Advance Value",
        type: "number",
        placeholder: "e.g. 100 or 10",
        helperText: "Amount in ₹ or percentage value.",
      },
      {
        name: "minimumAdvanceAmount",
        label: "Minimum Advance Amount",
        type: "number",
        placeholder: "e.g. 50",
        helperText: "Minimum advance threshold in ₹.",
      },
      {
        name: "minimumOrderAmount",
        label: "Minimum Order Amount required for Partial Payment",
        type: "number",
        placeholder: "e.g. 500",
        helperText:
          "Partial payment applies only if order total is above this.",
      },
      {
        name: "customerMessage",
        label: "Customer Checkout Message",
        type: "textarea",
        placeholder: "Enter message for customer...",
        helperText: "Message visible on frontend checkout page.",
      },
    ],
  },
  razorpay: {
    label: "Razorpay",
    image: "/img/icons/razorpay.webp",
    websiteUrl: "https://razorpay.com",
    description:
      "Accept online payments using UPI, Cards, Net Banking and Wallets through Razorpay.",
    setupSteps: [
      "Create your Razorpay account.",
      "Complete KYC and business verification.",
      "Go to Settings > API Keys.",
      "Generate Test or Live API Keys.",
      "Copy Key ID and Key Secret.",
      "Add Webhook URL in Razorpay webhook settings.",
      "Paste all credentials below and save settings.",
    ],

    fields: [
      {
        name: "apiKey",
        label: "API Key",
        placeholder: "Enter Razorpay Key ID",
        helperText: "Get this from Razorpay Dashboard > Settings > API Keys",
      },

      {
        name: "apiSecret",
        label: "API Secret",
        placeholder: "Enter Razorpay Secret Key",
        helperText: "Used to securely authenticate payment requests.",
      },

      {
        name: "webhookSecret",
        label: "Webhook Secret",
        placeholder: "Enter Webhook Secret",
        helperText: "Used to validate webhook events sent by Razorpay.",
      },

      {
        name: "mode",
        label: "Mode",
        type: "select",
        options: [
          { label: "Test", value: "test" },
          { label: "Live", value: "live" },
        ],
        helperText:
          "Use Test mode for testing and Live mode for real payments.",
      },
    ],
  },

  payu: {
    label: "PayU",
    image: "/img/icons/payu.webp",

    websiteUrl: "https://payu.in",

    description:
      "Accept payments securely using PayU payment gateway integration.",

    setupSteps: [
      "Create your PayU merchant account.",
      "Complete KYC and approval process.",
      "Go to Developer/API section in dashboard.",
      "Copy Merchant Key and Salt Key.",
      "Configure webhook/callback URL.",
      "Paste credentials below and save settings.",
    ],

    fields: [
      {
        name: "apiKey",
        label: "API Key",
        placeholder: "Enter PayU Merchant Key",
        helperText: "Available inside PayU merchant dashboard.",
      },

      {
        name: "saltKey",
        label: "Salt Key",
        placeholder: "Enter PayU Salt Key",
        helperText: "Used for payment signature generation and validation.",
      },

      {
        name: "webhookSecret",
        label: "Webhook Secret",
        placeholder: "Enter Webhook Secret",
        helperText: "Used to validate PayU server callbacks.",
      },

      {
        name: "mode",
        label: "Mode",
        type: "select",
        options: [
          { label: "Test", value: "test" },
          { label: "Live", value: "live" },
        ],
        helperText:
          "Select Test mode for sandbox payments or Live mode for production.",
      },
    ],
  },
};

export default GATEWAY_CONFIG;
